export default function PriceRangeController($scope, $timeout) {
    'ngInject';

    const vm = this;

    Object.assign(vm, {
        $onInit,
        startDrag,
        endDrag,
        updateModel,
        sliderChange,
        updateFromInput,
    });

    $scope.$watch(() => vm.minimum, (newValue) => {
        vm.inputMinimum = newValue;
        vm.sliderMinimum = newValue;
    });

    $scope.$watch(() => vm.maximum, (newValue) => {
        vm.inputMaximum = newValue;
        vm.sliderMaximum = newValue;
    });

    function $onInit() {
        initMinimumMaximum();
        vm.canBeUpdated = true;
    }

    function startDrag() {
        vm.canBeUpdated = false;
    }

    function endDrag() {
        vm.canBeUpdated = true;
        updateModel();
    }

    function updateFromInput() {
        vm.sliderMinimum = vm.inputMinimum;
        vm.sliderMaximum = vm.inputMaximum;
        updateModel();
    }

    function sliderChange() {
        vm.inputMinimum = vm.sliderMinimum;
        vm.inputMaximum = vm.sliderMaximum;
    }

    function updateModel() {
        if (vm.canBeUpdated) {
            vm.minimum = vm.sliderMinimum;
            vm.maximum = vm.sliderMaximum;
        }
    }

    function initMinimumMaximum() {
        const isSelectedPreviously = vm.minimum && vm.maximum;

        if (!isSelectedPreviously) {
            vm.maximum = vm.rangeValues.ceiling;
            vm.minimum = vm.rangeValues.floor;
        }

        vm.sliderMinimum = vm.minimum;
        vm.sliderMaximum = vm.maximum;
        vm.inputMinimum = vm.minimum;
        vm.inputMaximum = vm.maximum;

        $timeout(function() {
            $scope.$broadcast('rzSliderForceRender');
        }, 500);

        if (isSelectedPreviously) {
            $scope.$broadcast('rzSliderForceRender');
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/directives/price-range/price-range-controller.js